<template>
<!-- 入库备案数据页面/报表 -->
  <div id="CustomerOwnerDataReportTwo">
      <div id="right">
       <!-- 日期、组织架构 -->
<!-- <HeadControl ref="HeadControl" @changeVal="changeVal" @changDate="changDate" @changePicker="changePicker"></HeadControl> -->
      <!-- 报表 --> 
      <div class="reportView">
        <div class="BottomBox">
        <div id="OnepieChart" ref="OnepieChart"></div>
        <div id="Twohistogram" ref="Twohistogram"></div>
        </div>
        <div class="histogram">
        <div id="threemyChart" ref="threemyChart"></div>
        </div>
        <div class="otherStaffs" style="position:relative;">
        <el-radio-group :class="[$route.query.identification ? 'h5Position' : 'PCposition']" v-model="OtherPersonnelType" @change="getOtherPersonnel()" fill="#52D2A2" size="small">
          <el-radio-button label="CERTIFICATE_TYPE_SAFETY">安证人员</el-radio-button>
          <el-radio-button label="CERTIFICATE_TYPE_TITLE">职称人员</el-radio-button>
        </el-radio-group>
        <div id="otherStaffsEchart" ref="otherStaffsEchart"></div>
        </div>
      </div>
      </div>
  </div>
</template>

<script>
import * as Urls from '@/helper/Urls';
// import HeadControl from '@/components/HeadControl'
export default {
components:{
  // HeadControl
}, 
data() {
  return {
      screenWidth: document.body.clientWidth, // 屏幕宽度
      RegisteredPersonnelDataList:'', // 注册人员数据
      ManagerDataList:'', // 管理人员数据
      SkilledWorkersDataList:'', // 技术工人数据
      SkilledworkersEntries:'', 
      SkilledworkersPercent:'',
      managerEntries:'',
      managerPercent:'',
      registeredEntries:'',
      registeredPercent:'',
      OtherPersonnelList:'', // 安证人员数据
      OtherPersonnelType:'CERTIFICATE_TYPE_TITLE'
  };
},  
created(){
    
},
mounted(){
    // 屏幕宽度
    let _this = this;  
    window.onresize = () => {
      return (() => {
      window.screenWidth = document.body.clientWidth + 17; //实时宽度
      _this.screenWidth = window.screenWidth;
     })();
    };
    if(!this.$route.query.identification){
      this.init()
    }
},  
methods:{
    getOrgCode(){
        this.$refs.HeadControl.getSysOrg()
    },
    // 其他人员报表
    initChart4() {
      let widthPx = this.screenWidth;
      let Chart4 = this.$echarts.getInstanceByDom(this.$refs.otherStaffsEchart);
      if (Chart4 == null) {
        this.myChart4 = this.$echarts.init(this.$refs.otherStaffsEchart);
      }        
      const option = {
                textStyle: {
                  fontFamily: 'PingFang-M'
                },
                title: {
                text: '其他人员',
                top:'24',  
                left:this.$route.query.identification ? '20' : '30',
                textStyle:{
                    fontWeight:500,
                }
                },
                grid: {
                left:this.$route.query.identification ? '15' :  (this.screenWidth <= 1366 ? '4%' : '3%'),
                right:this.$route.query.identification ? '30' :  '3%',
                bottom: '20px',
                top:this.$route.query.identification ? '130' : '90px',
                containLabel: true
                },
                opacity:0.1,       
                tooltip: {
                  trigger: 'axis',
                  formatter:function(params){
                    // const str = `
                    //             <div>${params[0].axisValue}：${params[1].data}个</div>
                    //             <div>占比：${params[0].data}%</div>
                    // `
                  let h = `<div>`;
                  params.reverse().forEach(item => {
                    if (item.seriesIndex == 1) {
                      h += `<div>${item.axisValue}：${item.data}个</div>`;
                    } else {
                      h += `<div>占比：${item.data}%</div></div>`
                    }
                  });
                    return h
                  }
                },
                legend: {
                  data: this.OtherPersonnelList.legend,
                  itemWidth: 40,// 单个icon的width（单位px）
                  itemHeight: 8,// 单个icon的height（单位px）
                  itemGap:20,// 每个icon之间的距离（单位px）
                  left:this.$route.query.identification ? '110' : '350',
                  top:'24',
                textStyle: {
                    fontSize: '13',            
                    height: 10,
                     rich: {
                      a: {
                       verticalAlign: 'middle',
                   },
                 }
                },                  
                },
                xAxis: [
                  {
                    type: 'category',
                    offset:5,
                    data: this.OtherPersonnelList.xAxis.data,
                    axisPointer: {
                      type: 'shadow'
                    },
                    // 分隔线
                    splitLine: {
                      show: true,
                       lineStyle: {
                        color: '#DDDDDD'
                       },
                    },
                    axisTick:{
                      show:false,
                    },  
                    axisLine:{
                      show:true,
                      lineStyle:{
                        color:'#DDDDDD'
                      }
                    }, 
                    axisLabel:{
                      show:this.$route.query.identification ? false : true,
                    //   formatter: function(params) {
                    //    if(widthPx <= 1366){
                    //     var newParamsName = "";
                    //     var paramsNameNumber = params.length;
                    //     var provideNumber = 5; //一行显示几个字
                    //     var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                    //     if (paramsNameNumber > provideNumber) {
                    //       for (var p = 0; p < rowNumber; p++) {
                    //         var tempStr = "";
                    //         var start = p * provideNumber;
                    //         var end = start + provideNumber;
                    //         if (p == rowNumber - 1) {
                    //           tempStr = params.substring(start, paramsNameNumber);
                    //         } else {
                    //           tempStr = params.substring(start, end) + "\n";
                    //         }
                    //         newParamsName += tempStr;
                    //       }
                    //     } else {
                    //       newParamsName = params;
                    //     }
                    //     return newParamsName;
                    //   }else{
                    //     return params
                    //   }
                    // },
                    formatter: function(params,index) {
                        if(params.length >= 5){
                        var newParamsName = "";
                        var paramsNameNumber = params.length;
                        var provideNumber = 5 ; //一行显示几个字
                        var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                        if (paramsNameNumber > provideNumber) {
                          for (var p = 0; p < rowNumber; p++) {
                            var tempStr = "";
                            var start = p * provideNumber;
                            var end = start + provideNumber;
                            if (p == rowNumber - 1) {
                              tempStr = params.substring(start, paramsNameNumber);
                            } else {
                              tempStr = params.substring(start, end) + "\n";
                            }
                            newParamsName += tempStr;
                          }
                        } else {
                          newParamsName = params;
                        }
                        return newParamsName;
                        }else{
                          return params
                        }
                      },
                    textStyle:{
                      color:'#666666',
                    }
                    },
                    axisPointer: {
                      type: 'none'
                    }                                  
                  }
                ],
                yAxis: [
                  {
                    // 数据显示
                    offset:5,
                    type: 'value',
                    name: '百分比',
                    min: 0,
                    max: this.OtherPersonnelPercent,
                    // interval: 10,
                    splitNumber:5,
                    interval: this.OtherPersonnelPercent / 5,
                    axisLabel: {
                      formatter: '{value}%',
                      textStyle:{
                          color:'#666666'
                        }                      
                    },
                    // 分隔线
                    splitLine: {
                      show: true,
                       lineStyle: {
                        color: '#DDDDDD'
                       },
                    },
                    // 坐标轴名称的文字样式
                    nameTextStyle: {
                      color:'#666666',
                      padding:this.$route.query.identification ? [0,28,0,0] : [0,35,0,0]
                    },
                    axisTick:false, // 刻度
                    axisLine:{
                    show:false // 轴  
                  }              
                  },
                  {
                    type: 'value',
                    name: '证书数（个）',
                    min: 0,
                    max: this.OtherPersonnelEntries,
                    // interval: this.SkilledworkersEntries == 0 ? 1 : this.SkilledworkersEntries / (this.SkilledworkersPercent / 10),
                    splitNumber:5,
                    interval: this.OtherPersonnelEntries / 5,
                    axisLabel: {
                      formatter: params=>{
                        return parseInt(params)
                      },
                      textStyle:{
                          color:'#666666'
                        }
                    },
                    // 坐标轴名称的文字样式
                    nameTextStyle: {
                      color:'#666666',
                       padding:this.$route.query.identification ? [0,10,0,0] : [0,0,0,0]
                    },
                    axisTick:false, // 刻度
                    axisLine:{
                    show:false // 轴  
                    },
                    splitLine: {
                      show: false,
                    },
                  }
                ],
                series: [
                  {
                    name: this.OtherPersonnelList.series[0].name,
                    type: 'bar',
                    barWidth :'30%',
                    data: this.OtherPersonnelList.series[0].data,
                    itemStyle:{
                      normal:{
                      color:'rgba(97,217,172,0.35)',
                      borderColor:Math.max(...this.OtherPersonnelList.series[0].data)  == 0 ? 'rgba(87,185,255,0)' : 'rgba(97,217,172,1)'
                      }  
                    }
                  },
                  {
                    name: this.OtherPersonnelList.series[1].name,
                    type: 'line',
                    yAxisIndex: 1,
                    symbol:'rect',
                    symbolSize: 9,
                    hoverAnimation: false,
                    data: this.OtherPersonnelList.series[1].data,
                    itemStyle:{
                      normal:{
                      color:'rgba(87,185,255,1)',
                      opacity: Math.max(...this.OtherPersonnelList.series[1].data) == 0 ? 0 : 1,
                      } ,
                      emphasis: {          //突出效果配置(鼠标置于拐点上时)
                      borderWidth: 3,
                      borderColor: 'rgba(87,185,255,1)',
                      color: 'rgba(87,185,255,1)',
                      }, 
                    },
                   lineStyle:{
                      normal:{
                        opacity: Math.max(...this.OtherPersonnelList.series[1].data) == 0 ? 0 : 1,
                      }
                    },
                  },
                  
                ]
              };
      this.myChart4.setOption(option);
      window.addEventListener("resize", () => {
        if(this.$route.query.identification) {
          var resize = {
            width: this.screenWidth - 21,
          };
          this.myChart4.resize(resize)
        } else {
          this.myChart4.resize()
        }
      })   
    },
    // 获取其他人员
    getOtherPersonnel(){
      let _this = this
      let url =  Urls.getEchartsSkillReportItemData
      let params =  {
        itemCode:this.OtherPersonnelType
      }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }       
          _this.OtherPersonnelList = server_data.data
        }) 
    },
    // 技术工人报表
    initChart3() {
      let widthPx = this.screenWidth;
      let Chart3 = this.$echarts.getInstanceByDom(this.$refs.threemyChart);
      if (Chart3 == null) {
        this.myChart3 = this.$echarts.init(this.$refs.threemyChart);
      }        
      const option = {
                textStyle: {
                  fontFamily: 'PingFang-M'
                },
                title: {
                text: '技术工人',
                top:'24',  
                left:this.$route.query.identification ? '20' : '30',
                textStyle:{
                    fontWeight:500,
                }
                },
                grid: {
                left:this.$route.query.identification ? '15' :  (this.screenWidth <= 1366 ? '4%' : '3%'),
                right:this.$route.query.identification ? '30' :  '3%',
                bottom: '20px',
                top:'90px',
                containLabel: true
                },
                opacity:0.1,       
                tooltip: {
                  trigger: 'axis',
                  formatter:function(params){
                    // const str = `
                    //             <div>${params[0].axisValue}：${params[1].data}个</div>
                    //             <div>占比：${params[0].data}%</div>
                    // `
                  let h = `<div>`;
                  params.reverse().forEach(item => {
                    if (item.seriesIndex == 1) {
                      h += `<div>${item.axisValue}：${item.data}个</div>`;
                    } else {
                      h += `<div>占比：${item.data}%</div></div>`
                    }
                  });
                    return h
                  }
                },
                legend: {
                  data: this.SkilledWorkersDataList.legend,
                  itemWidth: 40,// 单个icon的width（单位px）
                  itemHeight: 8,// 单个icon的height（单位px）
                  itemGap:20,// 每个icon之间的距离（单位px）
                  left:this.$route.query.identification ? '110' : '200',
                  top:'24',
                textStyle: {
                    fontSize: '13',            
                    height: 10,
                     rich: {
                      a: {
                       verticalAlign: 'middle',
                   },
                 }
                },                  
                },
                xAxis: [
                  {
                    type: 'category',
                    offset:5,
                    data: this.SkilledWorkersDataList.xAxis.data,
                    axisPointer: {
                      type: 'shadow'
                    },
                    // 分隔线
                    splitLine: {
                      show: true,
                       lineStyle: {
                        color: '#DDDDDD'
                       },
                    },
                    axisTick:{
                      show:false,
                    },  
                    axisLine:{
                      show:true,
                      lineStyle:{
                        color:'#DDDDDD'
                      }
                    }, 
                    axisLabel:{
                      show:this.$route.query.identification ? false : true,
                      formatter: function(params) {
                       if(widthPx <= 1366){
                        var newParamsName = "";
                        var paramsNameNumber = params.length;
                        var provideNumber = 5; //一行显示几个字
                        var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                        if (paramsNameNumber > provideNumber) {
                          for (var p = 0; p < rowNumber; p++) {
                            var tempStr = "";
                            var start = p * provideNumber;
                            var end = start + provideNumber;
                            if (p == rowNumber - 1) {
                              tempStr = params.substring(start, paramsNameNumber);
                            } else {
                              tempStr = params.substring(start, end) + "\n";
                            }
                            newParamsName += tempStr;
                          }
                        } else {
                          newParamsName = params;
                        }
                        return newParamsName;
                      }else{
                        return params
                      }
                    },
                    textStyle:{
                      color:'#666666',
                    }
                    },
                    axisPointer: {
                      type: 'none'
                    }                                  
                  }
                ],
                yAxis: [
                  {
                    // 数据显示
                    offset:5,
                    type: 'value',
                    name: '百分比',
                    min: 0,
                    max: this.SkilledworkersPercent,
                    // interval: 10,
                    splitNumber:5,
                    interval: this.SkilledworkersPercent / 5,
                    axisLabel: {
                      formatter: '{value}%',
                      textStyle:{
                          color:'#666666'
                        }                      
                    },
                    // 分隔线
                    splitLine: {
                      show: true,
                       lineStyle: {
                        color: '#DDDDDD'
                       },
                    },
                    // 坐标轴名称的文字样式
                    nameTextStyle: {
                      color:'#666666',
                      padding:this.$route.query.identification ? [0,28,0,0] : [0,35,0,0]
                    },
                    axisTick:false, // 刻度
                    axisLine:{
                    show:false // 轴  
                  }              
                  },
                  {
                    type: 'value',
                    name: '证书数（个）',
                    min: 0,
                    max: this.SkilledworkersEntries,
                    // interval: this.SkilledworkersEntries == 0 ? 1 : this.SkilledworkersEntries / (this.SkilledworkersPercent / 10),
                    splitNumber:5,
                    interval: this.SkilledworkersEntries / 5,
                    axisLabel: {
                      formatter: params=>{
                        return parseInt(params)
                      },
                      textStyle:{
                          color:'#666666'
                        }
                    },
                    // 坐标轴名称的文字样式
                    nameTextStyle: {
                      color:'#666666',
                       padding:this.$route.query.identification ? [0,10,0,0] : [0,0,0,0]
                    },
                    axisTick:false, // 刻度
                    axisLine:{
                    show:false // 轴  
                    },
                    splitLine: {
                      show: false,
                    },
                  }
                ],
                series: [
                  {
                    name: this.SkilledWorkersDataList.series[0].name,
                    type: 'bar',
                    barWidth :'50%',
                    data: this.SkilledWorkersDataList.series[0].data,
                    itemStyle:{
                      normal:{
                      color:'rgba(97,217,172,0.35)',
                      borderColor:Math.max(...this.SkilledWorkersDataList.series[0].data)  == 0 ? 'rgba(87,185,255,0)' : 'rgba(97,217,172,1)'
                      }  
                    }
                  },
                  {
                    name: this.SkilledWorkersDataList.series[1].name,
                    type: 'line',
                    yAxisIndex: 1,
                    symbol:'rect',
                    symbolSize: 9,
                    hoverAnimation: false,
                    data: this.SkilledWorkersDataList.series[1].data,
                    itemStyle:{
                      normal:{
                      color:'rgba(87,185,255,1)',
                      opacity: Math.max(...this.SkilledWorkersDataList.series[1].data) == 0 ? 0 : 1,
                      } ,
                      emphasis: {          //突出效果配置(鼠标置于拐点上时)
                      borderWidth: 3,
                      borderColor: 'rgba(87,185,255,1)',
                      color: 'rgba(87,185,255,1)',
                      }, 
                    },
                   lineStyle:{
                      normal:{
                        opacity: Math.max(...this.SkilledWorkersDataList.series[1].data) == 0 ? 0 : 1,
                      }
                    },
                  },
                  
                ]
              };
      this.myChart3.setOption(option);
      window.addEventListener("resize", () => {
        if(this.$route.query.identification) {
          var resize = {
            width: this.screenWidth - 21,
          };
          this.myChart3.resize(resize)
        } else {
          this.myChart3.resize()
        }
      })   
    },
    // 获取技术工人数据
    getSkilledWorkersData(){
      let _this = this
      let url =  Urls.getEchartsSkillReportItemData
      let params =  {
        itemCode:'CERTIFICATE_TYPE_SKILL'
      }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }       
            _this.SkilledWorkersDataList = server_data.data
        })      
    },
     // 管理人员报表
     initChart2() { 
      let widthPx = this.screenWidth
      let Chart2 = this.$echarts.getInstanceByDom(this.$refs.Twohistogram);
      if (Chart2 == null) {
        this.myChart2 = this.$echarts.init(this.$refs.Twohistogram);
      }       
       const option = {
                  textStyle: {
                    fontFamily: 'PingFang-M'
                  },
                 title: {
                 text: '管理人员 ',
                 top:'24',  
                 left:this.$route.query.identification ? '20' : '30',
                 textStyle:{
                     fontWeight:500,
                 }
                 },       
                  // dataZoom: [{
                  //        type: 'slider',
                  //        show: this.$route.query.identification ? true : false,
                  //        xAxisIndex: [0],
                  //        left: '9%',
                  //        bottom: 10,
                  //        start: 15,
                  //        end: 0, //初始化滚动条
                  //        zoomLock:true,
                  //        height:20,
                  //        // borderColor: "#000",
                  //        borderRadius: 5,
                  //        // backgroundColor: '#33384b',//两边未选中的滑动条区域的颜色
                  //        showDataShadow: false,//是否显示数据阴影 默认auto
                  //        showDetail: false,//即拖拽时候是否显示详细数值信息 默认true
                  //        realtime: true, //是否实时更新
                  //        filterMode: 'filter',
                  //  }],
                 grid: {
                 left:this.$route.query.identification ? '15' : (this.screenWidth <= 1366 ? '4%' : '3%'),
                 right:this.$route.query.identification ? '30' : (this.screenWidth <= 1366 ? '6.5%' : '4.5%'),
                 bottom:this.$route.query.identification ? 40 :'20px',
                 top:'90px',
                 containLabel: true
                 },
                 opacity:0.1,       
                 tooltip: {
                   trigger: 'axis',
                   formatter:function(params){
                    let h = `<div>`;
                    params.forEach(item => {
                      if (item.seriesIndex == 1) {
                        h += `<div>${item.seriesName}：${item.data}个</div>`;
                      } else {
                        h += `<div>${item.seriesName}：${item.data}个</div>`
                      }
                    });                    
                     return h
                   }
                 },
                 legend: {
                   data: this.ManagerDataList.legend,
                   itemWidth: 40,// 单个icon的width（单位px）
                   itemHeight: 8,// 单个icon的height（单位px）
                   itemGap:20,// 每个icon之间的距离（单位px）
                   left:this.$route.query.identification ? '110' : '200',
                   top:'24',
                 textStyle: {
                     fontSize: '13',            
                     height: 10,
                      rich: {
                       a: {
                        verticalAlign: 'middle',
                    },
                  }
                 },                  
                 },
                 xAxis: [
                   {
                     type: 'category',
                     offset:5,
                     data: this.ManagerDataList.xAxis.data,
                     axisPointer: {
                       type: 'shadow'
                     },
                     // 分隔线
                     splitLine: {
                       show:true,
                        lineStyle: {
                         color: '#DDDDDD'
                        },
                     },
                     axisTick:{
                       show:false,
                     },  
                     axisLine:{
                       show:true,
                       lineStyle:{
                        color:'#DDDDDD'
                       }
                     }, 
                     axisLabel:{
                      color: '#666666',
                      formatter: function(params,index) {
                        if(params.length >= 4){
                        var newParamsName = "";
                        var paramsNameNumber = params.length;
                        var provideNumber = 3 ; //一行显示几个字
                        var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                        if (paramsNameNumber > provideNumber) {
                          for (var p = 0; p < rowNumber; p++) {
                            var tempStr = "";
                            var start = p * provideNumber;
                            var end = start + provideNumber;
                            if (p == rowNumber - 1) {
                              tempStr = params.substring(start, paramsNameNumber);
                            } else {
                              tempStr = params.substring(start, end) + "\n";
                            }
                            newParamsName += tempStr;
                          }
                        } else {
                          newParamsName = params;
                        }
                        return newParamsName;
                        }else{
                          return params
                        }
                      }
                      // rotate:this.$route.query.identification ? 54 : (widthPx <= 1366 ? 30 : 0),
                      // margin:15,
                     },
                     axisPointer: {
                      type: 'none'
                    }                                   
                   }
                 ],
                 yAxis: [
                   {
                     // 数据显示
                     offset:5,
                     type: 'value',
                     name: '证书数（个）',
                     min: 0,
                     max:this.managerPercent,
                    splitNumber:5,
                    interval: this.managerPercent / 5,
                     axisLabel: {
                       formatter: '{value}',
                        textStyle:{
                          color:'#666666'
                        }
                     },
                     // 分隔线
                     splitLine: {
                       show: true,
                        lineStyle: {
                         color: '#dddddd'
                        },
                     },
                     // 坐标轴名称的文字样式
                     nameTextStyle: {
                       color:'#666666',
                       padding:this.$route.query.identification ? [0,0,0,25] : [0,0,0,17]
                     },
                     axisTick:false, // 刻度
                     axisLine:{
                     show:false // 轴  
                   }              
                   },
                   {
                     type: 'value',
                     name: '锁证数（个）',
                     min: 0,
                     max:this.managerEntries,
                    //  interval: this.managerEntries===0 ? 1:this.managerEntries / (this.managerPercent / 5),
                    splitNumber:5,
                    interval: this.managerEntries / 5,
                     axisLabel: {
                       formatter: params=>{
                        return parseInt(params) 
                       },
                      textStyle:{
                          color:'#666666'
                        }
                     },
                     // 坐标轴名称的文字样式
                     nameTextStyle: {
                        color:'#666666',
                        padding: this.$route.query.identification ? [0,20,0,0] :[0,0,0,0]
                     },
                     axisTick:false, // 刻度
                     axisLine:{
                     show:false // 轴  
                   }                    
                   }
                 ],
                 series: [
                   {
                     name: this.ManagerDataList.series[0].name,
                     type: 'bar',
                     barWidth :'60%',
                     data: this.ManagerDataList.series[0].data,
                     itemStyle:{
                       normal:{
                       color:'rgba(87,185,255,0.35)',
                       borderColor:Math.max(...this.ManagerDataList.series[0].data)  == 0 ? 'rgba(87,185,255,0)' : 'rgba(87,185,255,1)'
                       }  
                     }
                   },
                   {
                     name: this.ManagerDataList.series[1].name,
                     type: 'line',
                     symbol:'rect',
                     symbolSize: 10,
                     hoverAnimation: false,
                     data: this.ManagerDataList.series[1].data,
                     itemStyle:{
                       normal:{
                       color:'#72d8c0',
                       opacity: Math.max(...this.ManagerDataList.series[1].data) == 0 ? 0 : 1,
                       } ,
                       emphasis: {          //突出效果配置(鼠标置于拐点上时)
                       borderWidth: 3,
                       borderColor: '#61d9ac',
                       color: '#61d9ac',
                       }, 
                     },
                     lineStyle:{
                       normal:{
                         opacity: Math.max(...this.ManagerDataList.series[1].data) == 0 ? 0 : 1,
                       }
                     }, 
                   },
                
                 ]
       };
       if(this.$route.query.identification){
          option.dataZoom = [{
                         type: 'slider',
                         show: this.$route.query.identification ? true : false,
                         xAxisIndex: [0],
                         left: '9%',
                         bottom: 10,
                         start: 15,
                         end: 0, //初始化滚动条
                         zoomLock:true,
                         height:20,
                         // borderColor: "#000",
                         borderRadius: 5,
                         // backgroundColor: '#33384b',//两边未选中的滑动条区域的颜色
                         showDataShadow: false,//是否显示数据阴影 默认auto
                         showDetail: false,//即拖拽时候是否显示详细数值信息 默认true
                         realtime: true, //是否实时更新
                         filterMode: 'filter',
          }]
       }
      this.myChart2.setOption(option);
      window.addEventListener("resize", () => {
        if(this.$route.query.identification) {
          var resize = {
            width: this.screenWidth - 21,
          };
          this.myChart2.resize(resize)
        } else {
          this.myChart2.resize()
        }
      })      
     },
     // 获取管理人员
    getManagerData(){
       let _this = this
       let url = Urls.getEchartsRegisterAndManageReportItemData
       let params = {
         itemCode:'CERTIFICATE_TYPE_MANAGE'        
       }
         this.$root.doPost(url,params,function(server_data){
             // 用户没有登录
            if( !_this.$root.isUserLogin(server_data)){
            return;
          }

          // 应用错误
          if(server_data.error){
              _this.$root.showGlobalError(server_data.error);
              return;
          }
             _this.ManagerDataList = server_data.data
         })        
    },
    // 注册人员报表
    initChart1() {
      let identification = this.$route.query.identification
      let legend = this.RegisteredPersonnelDataList.legend
      let xAxisList = this.RegisteredPersonnelDataList.xAxis.data
      let Chart1 = this.$echarts.getInstanceByDom(this.$refs.OnepieChart);
      let widthPx = this.screenWidth
      if (Chart1 == null) {
        this.myChart1 = this.$echarts.init(this.$refs.OnepieChart);
      }      
      const option = {
                textStyle: {
                  fontFamily: 'PingFang-M'
                },
                title: {
                text: '注册人员',
                top:'24',  
                left:this.$route.query.identification ? '20' : '30',
                textStyle:{
                    fontWeight:500,
                }
                },
                grid: { 
                left:this.$route.query.identification ? '15' : (this.screenWidth <= 1366 ? '4%' : '3%'),
                right: this.$route.query.identification ? '30' :(this.screenWidth <= 1366 ? '7%' : '4.5%'),
                bottom: this.$route.query.identification ? 40 : '20px',
                top:'90px',
                containLabel: true
                },
                opacity:0.1,       
                tooltip: {
                  trigger: 'axis',
                  formatter:function(params){
                    let h = `<div>`;
                    params.forEach(item => {
                      if (item.seriesIndex == 1) {
                        h += `<div>${item.seriesName}：${item.data}个</div>`;
                      } else {
                        h += `<div>${item.seriesName}：${item.data}个</div>`
                      }
                    });                    
                     return h
                  }
                },
                legend: {
                  data: legend,
                  itemWidth: 40,// 单个icon的width（单位px）
                  itemHeight: 8,// 单个icon的height（单位px）
                  itemGap: 20,// 每个icon之间的距离（单位px）
                  left:this.$route.query.identification ? '110' :'200',
                  top:'24',
                textStyle: {
                    fontSize: '13',            
                    height: 10,
                     rich: {
                      a: {
                       verticalAlign: 'middle',
                   },
                 }
                },                  
                },
                xAxis: [
                  {
                    type: 'category',
                    offset:5,
                    data: this.RegisteredPersonnelDataList.xAxis.data,
                    axisPointer: {
                      type: 'shadow'
                    },
                    // 分隔线
                    splitLine: {
                      show: true,
                       lineStyle: {
                        color: '#DDDDDD'
                       },
                    },
                    axisTick:{
                      show:false,
                    },  
                    axisLine:{
                      show:true,
                      lineStyle:{
                        color:'#DDDDDD'
                      }
                    }, 
                    axisLabel:{
                      // rotate:54,
                      // margin:15,
                      color: '#A1A7B3',
                      formatter: function(params,index) {
                        if(xAxisList.length >= 8){
                        var newParamsName = "";
                        var paramsNameNumber = params.length;
                        var provideNumber = identification  ? 5 : 5 ; //一行显示几个字
                        var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                        if (paramsNameNumber > provideNumber) {
                          for (var p = 0; p < rowNumber; p++) {
                            var tempStr = "";
                            var start = p * provideNumber;
                            var end = start + provideNumber;
                            if (p == rowNumber - 1) {
                              tempStr = params.substring(start, paramsNameNumber);
                            } else {
                              tempStr = params.substring(start, end) + "\n";
                            }
                            newParamsName += tempStr;
                          }
                        } else {
                          newParamsName = params;
                        }
                        return newParamsName;
                        }else{
                          return params
                        }
                    },
                    textStyle:{
                      color:'#666666'
                    }
                    }, 
                    axisPointer: {
                      type: 'none'
                    }                                 
                  }
                ],
                yAxis: [
                  {
                    // 数据显示
                    offset:5,
                    type: 'value',
                    name: '证书数（个）',
                    min: 0,
                    max:this.registeredPercent,
                    splitNumber:5,
                    interval: this.registeredPercent / 5,
                    axisLabel: {
                      formatter: '{value}',
                      textStyle:{
                          color:'#666666'
                      }
                    },
                    // 分隔线
                    splitLine: {
                      show: true,
                        lineStyle: {
                         color: '#dddddd'
                        },
                    },
                    // 坐标轴名称的文字样式
                    nameTextStyle: {
                      color:'#666666',
                      padding:this.$route.query.identification ? [0,0,0,25] : [0,0,0,17]
                    },
                    axisTick:{
                      show:false
                    }, // 刻度
                    axisLine:{
                    show:false // 轴  
                  }              
                  },
                  {
                    type: 'value',
                    name: '锁证数（个）',
                    min: 0,
                    max: this.registeredEntries,
                    splitNumber:5,
                    interval: this.registeredEntries / 5,
                    axisLabel: {
                      formatter:params=>{
                        return parseInt(params) 
                      },
                      textStyle:{
                          color:'#666666'
                      }
                    },
                    splitLine: {
                      show: true,
                        lineStyle: {
                         color: '#dddddd'
                        },
                    },
                    // 坐标轴名称的文字样式
                    nameTextStyle: {
                       padding: [0,0,0,0],
                       color:'#666666'
                    },
                    axisTick:false, // 刻度
                    axisLine:{
                    show:false // 轴  
                  }                    
                  }
                ],
                series: [
                  {
                    name: this.RegisteredPersonnelDataList.series[0].name,
                    type: 'bar',
                    barWidth : '70%',
                    data: this.RegisteredPersonnelDataList.series[0].data,
                    itemStyle:{
                      normal:{
                       color:'rgba(87,185,255,0.35)',
                      // opacity:0.7,
                      borderColor:Math.max(...this.RegisteredPersonnelDataList.series[0].data)  == 0 ? 'rgba(87,185,255,0)' : 'rgba(87,185,255,1)'
                      }  
                    }
                  },
                  {
                    name: this.RegisteredPersonnelDataList.series[1].name,
                    type: 'line',
                    symbol:'rect',
                    symbolSize: 9,
                    hoverAnimation: false,
                    data: this.RegisteredPersonnelDataList.series[1].data,
                    itemStyle:{
                      normal:{
                       color:'#72d8c0',
                       opacity: Math.max(...this.RegisteredPersonnelDataList.series[1].data) == 0 ? 0 : 1,
                      },
                      emphasis: {          //突出效果配置(鼠标置于拐点上时)
                      borderWidth: 3,
                      borderColor: '#61d9ac',
                      color: '#61d9ac',
                      }, 
                    },
                   lineStyle:{
                      normal:{
                        opacity: Math.max(...this.RegisteredPersonnelDataList.series[1].data) == 0 ? 0 : 1,
                      }
                    },
                  },
                  
                ]
      };
      if(this.$route.query.identification){
        option.dataZoom = [{
                        type: 'slider',
                        show: this.$route.query.identification ? true : false,
                        xAxisIndex: [0],
                        left: '9%',
                        bottom: 10,
                        start: 25,
                        end: 0, //初始化滚动条
                        zoomLock:true,
                        height:20,
                        // borderColor: "#000",
                        borderRadius: 5,
                        // backgroundColor: '#33384b',//两边未选中的滑动条区域的颜色
                        showDataShadow: false,//是否显示数据阴影 默认auto
                        showDetail: false,//即拖拽时候是否显示详细数值信息 默认true
                        realtime: true, //是否实时更新
                        filterMode: 'filter',
                }]
      }
      this.myChart1.setOption(option);
      window.addEventListener("resize", () => {
        if(this.$route.query.identification) {
          var resize = {
            width: this.screenWidth - 21,
          };
          this.myChart1.resize(resize)
        } else {
          this.myChart1.resize()
        }
      })       
    },     
    // 获取注册人员
    getRegisteredPersonnelData(){
      let _this = this
      let url = Urls.getEchartsRegisterAndManageReportItemData
      let params = {
        itemCode:'CERTIFICATE_TYPE_REGISTER'  
      }
        this.$root.doPost(url,params,function(server_data){
            // 用户没有登录
           if( !_this.$root.isUserLogin(server_data)){
           return;
         }

         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }  
            
            _this.RegisteredPersonnelDataList = server_data.data
        }) 
    },
    // H5调用
    init(){
    if(this.$route.query.identification){
      this.getRegisteredPersonnelData()
      this.getManagerData()
      this.getSkilledWorkersData()  
      this.getOtherPersonnel('CERTIFICATE_TYPE_SAFETY')
      return
    }
    
    this.getRegisteredPersonnelData()
    this.getManagerData()
    this.getSkilledWorkersData()   
    this.getOtherPersonnel('CERTIFICATE_TYPE_SAFETY')

    }
},
watch:{
  // 注册人员
  RegisteredPersonnelDataList(val){
    this.registeredEntries = Math.ceil(Math.max(...val.series[1].data) / 10) * 10
    this.registeredPercent = Math.ceil(Math.max(...val.series[0].data) / 10) * 10
    this.$nextTick(function () {
      var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
      window.dispatchEvent(myEvent); // 事件可以在任何元素触发
    }) 
    this.initChart1()
  },
  // 管理人员
  ManagerDataList(val){
    this.managerEntries = Math.ceil(Math.max(...val.series[1].data) / 10) * 10
    this.managerPercent = Math.ceil(Math.max(...val.series[0].data) / 10) * 10
    this.$nextTick(function () {
      var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
      window.dispatchEvent(myEvent); // 事件可以在任何元素触发
    })        
    this.initChart2()
  },
  // 技术工人
  SkilledWorkersDataList(val){
    this.SkilledworkersEntries = Math.ceil(Math.max(...val.series[1].data) / 10) * 10
    this.SkilledworkersPercent = Math.ceil(Math.max(...val.series[0].data) / 10) * 10
    this.$nextTick(function () {
      var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
      window.dispatchEvent(myEvent); // 事件可以在任何元素触发
    })        
    this.initChart3()
  },
  // 安证人员
  OtherPersonnelList(val){
    this. OtherPersonnelEntries = Math.ceil(Math.max(...val.series[1].data) / 10) * 10
    this. OtherPersonnelPercent = Math.ceil(Math.max(...val.series[0].data) / 10) * 10
    this.$nextTick(function () {
      var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
      window.dispatchEvent(myEvent); // 事件可以在任何元素触发
    })  
    // this.OtherPersonnelList = []
    this.OtherPersonnelList = val
    console.log(this.OtherPersonnelList,'123123')
    this.initChart4()
  }
}
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
#CustomerOwnerDataReportTwo{
  .PCposition{
    position:absolute; 
    top:22px;
    left:130px
    ;z-index: 999;
    border:1px solid #52D2A2;
  }
  .h5Position{
    position:absolute; 
    top:55px;
    left:180px
    ;z-index: 999;
    border:1px solid #52D2A2;
  }
  #right{
     box-sizing: border-box;
     .reportView{
     .histogram{
        width: 100%;
        height: 5.5rem;
        margin-top: 0.24rem;
        #threemyChart{
         width: 100%;
         height: 5.5rem; 
         background-color: #fff;
         -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         border-radius:0.1rem;
        }
     }
     .otherStaffs{
        width: 100%;
        height: 5rem;
        margin-top: 0.24rem;
        #otherStaffsEchart{
         width: 100%;
         height: 5rem; 
         background-color: #fff;
         -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         border-radius:0.1rem;
        }
     }
     .BottomBox{
      margin-top: 0.29rem;
      display: flex;
      flex-direction: column;
      #OnepieChart{
        height: 4.6rem;
        width: 100%;
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         border-radius:0.1rem;
      }
      #Twohistogram{
        height: 4.6rem;
        width: 100%;
        background-color: #fff;
        margin-top: 0.24rem;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         border-radius:0.1rem;
      }
     }
     }
     


  }
}
@media screen and (max-width: 768px) {
  #CustomerOwnerDataReportTwo{
    #right{
      box-sizing: border-box;
      .reportView{
        .BottomBox{
          box-sizing: border-box;
          margin: 0.14rem 0;
          flex-direction: column;
          padding: 0 0.12rem;
          width: 100%;
          #OnepieChart,#Twohistogram{
            width: 100%;
            border: none;
            margin-left: 0;
            margin-right: 0;
            background-color: #fff !important;
          }
          #Twohistogram{
            margin-top: 0.14rem;
          }
        }
        .histogram{
          padding: 0 0.12rem;
          margin-top: 0;
          width: 100%;
          box-sizing: border-box;
          #threemyChart{
            width: 100%;
            background-color: #fff !important;
            -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            border-radius:0.1rem;
            border: none;
          }
        }
        .otherStaffs{
        width: 100%;
        height: 5rem;
        padding: 0 0.12rem;
        margin-top: 0.24rem;
        box-sizing: border-box;
        #otherStaffsEchart{
         width: 100%;
         height: 5rem; 
         background-color: #fff !important;
         -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         border-radius:0.1rem;
         border: none;
        }
     }
      }
    }
  }
}
</style>
<style lang="scss">
#CustomerOwnerDataReportTwo{

  .el-radio-group{
    .el-radio-button{
      .el-radio-button__inner{
        border: none !important;
        border-radius:0 !important;
      }
    }
  }
  .el-radio-button:last-child .el-radio-button__inner {
        border-radius:0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// EliteCertificateDataReportTwo.vue?a29e44b8